import dayjs from 'dayjs';

export const STORE_HOURS_DATE_FORMAT = 'YYYY-MM-DD';

export const getStoreHoursCalendarDate = date => {
  if (!date) {
    return null;
  }

  if (dayjs.isDayjs(date) || date instanceof Date) {
    return dayjs(date).format(STORE_HOURS_DATE_FORMAT);
  }

  const dateString = String(date);
  const calendarDate = dateString.match(/^\d{4}-\d{2}-\d{2}/)?.[0];
  if (calendarDate) {
    return calendarDate;
  }

  return dayjs(date).format(STORE_HOURS_DATE_FORMAT);
};
